export enum BrandedIdType {
  NONE = 'NONE',
  BMW = 'BMW',
  MINI = 'MINI',
}
